module.exports = __webpack_public_path__ + "static/media/logo_esn_invert_fr.1c7e5080.svg";